import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import CheckBoxGroup from "./components/CheckBoxGroup";
import CheckBoxGroupSettings from "./components/CheckBoxGroupSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/check_box_setting.svg";
import { getLocale, defaultTarget, defaultOpts } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'checkBoxGroup', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.SELECT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_CHECKBOXGROUP'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: {
      formItemSettings: {
        options: defaultOpts,
        optionType: 'default',
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_CHECKBOXGROUP'],
      },
      settings: {
        width: {
          value: '100%',
        },
      },
    },
    pluginComponent: CheckBoxGroup, // 插件渲染组件
    pluginSettingComponent: CheckBoxGroupSettings, // 插件设置项组件
  }
}
